<div class="container">

  <!-- PRODUCTO -->
  <div class="card">
    <app-agricola-stepper
      [steps]="steps"
      [currentStep]="selectedIndex"
      (backClick)="onBackClick()"
      (stepClick)="goToStep($event)">
    </app-agricola-stepper>

    <h2>Selección de producto</h2>
    <p>Selecciona el producto para el cliente</p>

    <div class="insured-block">
      <div class="product-grid" [formGroup]="productSelection">
        <div class="field">
          <app-sis-select label="Selecciona el aliado" [options]="allyOptions" formControlName="ally"></app-sis-select>
        </div>

        <div class="field">
          <app-sis-select
            label="Selecciona el producto"
            [options]="productOptions"
            [loading]="loadingProducts"
            [loadedKey]="productsLoadedKey"
            loadedMessage="Catálogo de productos cargado"
            [loadFailed]="productsLoadFailed"
            (retryLoad)="retryLoadProducts()"

            [helper]="loadingProducts ? 'Cargando productos...' : ''"
            formControlName="product">
          </app-sis-select>
        </div>

        <div class="apply-group">
          <p class="product-premium" *ngIf="appliedProductPremium">
            Prima desde <strong>{{ appliedProductPremium }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- DATOS PRINCIPALES -->
  <div class="card">
    <h2>Datos principales</h2>
    <p>Ingresa algunos datos de forma manual</p>

    <div class="insured-block">
      <div class="subtitle">
        <span>Asegurado/Tomador</span>
      </div>
      <div class="subtitle client-summary">
        <span class="client-summary-item">
          <span class="client-summary-label">Nombre de cliente:</span>
          <span class="client-summary-value">{{ clientDisplayName }}</span>
        </span>
        <span class="client-summary-item" *ngIf="clientUniqueNumber">
          <span class="client-summary-label">Número único:</span>
          <span class="client-summary-value">{{ clientUniqueNumber }}</span>
        </span>
        <span class="client-summary-item" *ngIf="clientLinkage">
          <span class="client-summary-label">Vinculación:</span>
          <span class="client-summary-value">{{ clientLinkage }}</span>
        </span>
      </div>
  
      <div class="grid" [formGroup]="mainData" *ngIf="!usesAgricolaHolderLayout; else agricolaMainDataFields">
        <div class="field">
          <app-sis-field label="Primer nombre" [locked]="isClientFieldLocked('firstName')" [error]="fieldError('mainData', 'firstName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="firstName"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-field label="Segundo nombre" [locked]="isClientFieldLocked('middleName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="middleName"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-field label="Primer apellido" [locked]="isClientFieldLocked('firstLastName')" [error]="fieldError('mainData', 'firstLastName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="firstLastName"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-field label="Segundo apellido" [locked]="isClientFieldLocked('secondLastName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="secondLastName"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-field label="Apellido de casado/a" [locked]="isClientFieldLocked('marriedLastName')" [error]="fieldError('mainData', 'marriedLastName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="marriedLastName"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-field label="Número de NIT" [locked]="isClientFieldLocked('nit')" [error]="fieldError('mainData', 'nit')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="nit"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-select
            label="Tipo de documento"
            [options]="documentTypeStaticOptions"
            [locked]="isClientFieldLocked('documentType')"
            [error]="fieldError('mainData', 'documentType')"
            formControlName="documentType">
          </app-sis-select>
        </div>

        <div class="field">
          <app-sis-field label="Número de documento" [locked]="isClientFieldLocked('documentNumber')" [error]="fieldError('mainData', 'documentNumber')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="documentNumber"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-date-field label="Fecha de nacimiento" [locked]="isClientFieldLocked('birthDate')" [error]="fieldError('mainData', 'birthDate')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="birthDate"></app-sis-date-field>
        </div>

        <div class="field">
          <app-sis-field label="Edad" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="age"></app-sis-field>
        </div>

        <div class="field">
          <app-sis-select
            label="Género"
            [options]="genderOptions"
            [locked]="isClientFieldLocked('gender')"
            [loading]="loadingGenders || holderLoading"
            [loadedKey]="gendersLoadedKey + holderLoadedKey"
            loadedMessage="Catálogo de géneros cargado"
            [loadFailed]="gendersLoadFailed"
            (retryLoad)="retryLoadGenders()"
            [error]="fieldError('mainData', 'gender')"
            [helper]="loadingGenders ? 'Cargando géneros...' : ''"
            formControlName="gender">
          </app-sis-select>
        </div>
      </div>

      <ng-template #agricolaMainDataFields>
        <div class="grid" [formGroup]="mainData">
          <div class="field">
            <app-sis-select
              label="Tipo de Identificación"
              [options]="identificationTypeOptions"
              [locked]="isClientFieldLocked('documentType')"
              [loading]="loadingIdentificationTypes || holderLoading"
              [loadedKey]="identificationTypesLoadedKey + holderLoadedKey"
              loadedMessage="Catálogo de tipos de identificación cargado"
              [loadFailed]="identificationTypesLoadFailed"
              (retryLoad)="retryLoadIdentificationTypes()"
              [error]="fieldError('mainData', 'documentType')"

              [helper]="loadingIdentificationTypes ? 'Cargando tipos...' : ''"
              formControlName="documentType">
            </app-sis-select>
          </div>

          <div class="field">
            <app-sis-field label="Número de Identificación" [locked]="isClientFieldLocked('documentNumber')" [error]="fieldError('mainData', 'documentNumber')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="documentNumber"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Código" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="code"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Número de NIT" [locked]="isClientFieldLocked('nit')" [error]="fieldError('mainData', 'nit')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="nit"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Primer Nombre" [error]="fieldError('mainData', 'firstName')" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="firstName"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Segundo Nombre" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="middleName"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Primer Apellido" [error]="fieldError('mainData', 'firstLastName')" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="firstLastName"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Segundo Apellido" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="secondLastName"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-field label="Apellido de casado/a" [locked]="isClientFieldLocked('marriedLastName')" [error]="fieldError('mainData', 'marriedLastName')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="marriedLastName"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-date-field label="Fecha de Nacimiento" [locked]="isClientFieldLocked('birthDate')" [error]="fieldError('mainData', 'birthDate')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="birthDate"></app-sis-date-field>
          </div>

          <div class="field">
            <app-sis-field label="Edad" [readonly]="true" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="age"></app-sis-field>
          </div>

          <div class="field">
            <app-sis-select
              label="Género"
              [options]="genderOptions"
              [locked]="isClientFieldLocked('gender')"
              [loading]="loadingGenders || holderLoading"
              [loadedKey]="gendersLoadedKey + holderLoadedKey"
              loadedMessage="Catálogo de géneros cargado"
              [loadFailed]="gendersLoadFailed"
              (retryLoad)="retryLoadGenders()"
              [error]="fieldError('mainData', 'gender')"

              [helper]="loadingGenders ? 'Cargando géneros...' : ''"
              formControlName="gender">
            </app-sis-select>
          </div>
        </div>
      </ng-template>
    </div>
    
  </div>

  <!-- DATOS COMPLEMENTARIOS -->
  <div class="card">
    <h2>Datos complementarios</h2>
    <p>Ingresa algunos datos de forma manual</p>

    <div class="insured-block">
      <div class="grid" [formGroup]="complementary" *ngIf="!usesAgricolaHolderLayout; else agricolaComplementaryFields">
        <div class="field">
          <app-sis-select
            label="País de residencia"
            [options]="countryOptions"
            [locked]="isClientFieldLocked('country')"
            [loading]="loadingCountries || holderLoading"
            [loadedKey]="countriesLoadedKey + holderLoadedKey"
            loadedMessage="Catálogo de países cargado"
            [loadFailed]="countriesLoadFailed"
            (retryLoad)="retryLoadCountries()"
            [error]="fieldError('complementary', 'country')"

            [helper]="loadingCountries ? 'Cargando países...' : ''"
            formControlName="country">
          </app-sis-select>
        </div>
        <div class="field"><app-sis-field label="Nacionalidad" [locked]="isClientFieldLocked('nationality')" [error]="fieldError('complementary', 'nationality')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="nationality"></app-sis-field></div>

        <div class="field"><app-sis-field label="Dirección" [locked]="isClientFieldLocked('address')" [error]="fieldError('complementary', 'address')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="address"></app-sis-field></div>
        <div class="field" *ngIf="isElSalvadorSelected">
          <app-sis-select
            label="Departamento"
            placeholder="Selecciona un departamento"
            [options]="departmentOptions"
            [loading]="loadingStates"
            [loadedKey]="statesLoadedKey"
            loadedMessage="Catálogo de departamentos cargado"
            [loadFailed]="statesLoadFailed"
            (retryLoad)="retryLoadStates()"
            [error]="fieldError('complementary', 'department')"

            [helper]="loadingStates ? 'Cargando departamentos...' : ''"
            formControlName="department">
          </app-sis-select>
        </div>
        <div class="field" *ngIf="isElSalvadorSelected">
          <app-sis-select
            label="Municipio"
            placeholder="Selecciona un municipio"
            [options]="municipalityOptions"
            [disabled]="!departmentOptions.length"
            [loading]="loadingSubstates"
            [loadedKey]="substatesLoadedKey"
            loadedMessage="Catálogo de municipios cargado"
            [loadFailed]="substatesLoadFailed"
            (retryLoad)="retryLoadSubstates()"
            [error]="fieldError('complementary', 'municipality')"

            [helper]="loadingSubstates ? 'Cargando municipios...' : ''"
            formControlName="municipality">
          </app-sis-select>
        </div>
        <div class="field" *ngIf="isElSalvadorSelected">
          <app-sis-select
            label="Distrito"
            placeholder="Selecciona un distrito"
            [options]="cityOptions"
            [disabled]="!municipalityOptions.length"
            [loading]="loadingCities"
            [loadedKey]="citiesLoadedKey"
            loadedMessage="Catálogo de distritos cargado"
            [loadFailed]="citiesLoadFailed"
            (retryLoad)="retryLoadCities()"
            [error]="fieldError('complementary', 'district')"

            [helper]="loadingCities ? 'Cargando distritos...' : ''"
            formControlName="district">
          </app-sis-select>
        </div>

        <div class="field"><app-sis-field label="Correo electrónico" [error]="fieldError('complementary', 'email')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="email"></app-sis-field></div>
        <div class="field"><app-sis-field label="Teléfono" [locked]="isClientFieldLocked('phone')" [error]="fieldError('complementary', 'phone')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="phone"></app-sis-field></div>
        <div class="field"><app-sis-field label="Celular" [locked]="isClientFieldLocked('mobile')" [error]="fieldError('complementary', 'mobile')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="mobile"></app-sis-field></div>

        <div class="field">
          <app-sis-date-field label="Fecha de Inicio de Vigencia" [error]="fieldError('complementary', 'effectiveDate')" formControlName="effectiveDate"></app-sis-date-field>
        </div>
      </div>

      <ng-template #agricolaComplementaryFields>
        <div class="grid" [formGroup]="complementary">
          <div class="field"><app-sis-field label="Teléfono" type="number" [locked]="isClientFieldLocked('phone')" [error]="fieldError('complementary', 'phone')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="phone"></app-sis-field></div>
          <div class="field"><app-sis-field label="Teléfono 2" type="number" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="phone2"></app-sis-field></div>
          <div class="field"><app-sis-field label="Celular" type="number" [locked]="isClientFieldLocked('mobile')" [error]="fieldError('complementary', 'mobile')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="mobile"></app-sis-field></div>
          <div class="field"><app-sis-field label="Correo" type="email" [error]="fieldError('complementary', 'email')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="email"></app-sis-field></div>

          <div class="field">
            <app-sis-select
              label="Origen"
              [options]="countryOptions"
              [locked]="isClientFieldLocked('country')"
              [loading]="loadingCountries || holderLoading"
              [loadedKey]="countriesLoadedKey + holderLoadedKey"
              loadedMessage="Catálogo de países cargado"
              [loadFailed]="countriesLoadFailed"
              (retryLoad)="retryLoadCountries()"
              [error]="fieldError('complementary', 'country')"
  
              [helper]="loadingCountries ? 'Cargando países...' : ''"
              formControlName="country">
            </app-sis-select>
          </div>

          <div class="field"><app-sis-field label="Nacionalidad" [locked]="isClientFieldLocked('nationality')" [error]="fieldError('complementary', 'nationality')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="nationality"></app-sis-field></div>

          <div class="field"><app-sis-field label="Dirección" [locked]="isClientFieldLocked('address')" [error]="fieldError('complementary', 'address')" [loading]="holderLoading" [loadedKey]="holderLoadedKey" loadedMessage="Datos del cliente cargados" formControlName="address"></app-sis-field></div>

          <div class="field" *ngIf="isElSalvadorSelected">
            <app-sis-select
              label="Departamento"
              placeholder="Selecciona un departamento"
              [options]="departmentOptions"
              [loading]="loadingStates"
              [loadedKey]="statesLoadedKey"
              loadedMessage="Catálogo de departamentos cargado"
              [loadFailed]="statesLoadFailed"
              [error]="fieldError('complementary', 'department')"

              [helper]="loadingStates ? 'Cargando departamentos...' : ''"
              formControlName="department">
            </app-sis-select>
          </div>

          <div class="field" *ngIf="isElSalvadorSelected">
            <app-sis-select
              label="Municipio"
              placeholder="Selecciona un municipio"
              [options]="municipalityOptions"
              [disabled]="!departmentOptions.length"
              [loading]="loadingSubstates"
              [loadedKey]="substatesLoadedKey"
              loadedMessage="Catálogo de municipios cargado"
              [loadFailed]="substatesLoadFailed"
              [error]="fieldError('complementary', 'municipality')"

              [helper]="loadingSubstates ? 'Cargando municipios...' : ''"
              formControlName="municipality">
            </app-sis-select>
          </div>

          <div class="field" *ngIf="isElSalvadorSelected">
            <app-sis-select
              label="Ciudad"
              placeholder="Selecciona una ciudad"
              [options]="cityOptions"
              [disabled]="!municipalityOptions.length"
              [loading]="loadingCities"
              [loadedKey]="citiesLoadedKey"
              loadedMessage="Catálogo de ciudades cargado"
              [loadFailed]="citiesLoadFailed"
              (retryLoad)="retryLoadCities()"
              [error]="fieldError('complementary', 'district')"

              [helper]="loadingCities ? 'Cargando ciudades...' : ''"
              formControlName="district">
            </app-sis-select>
          </div>

          <div class="field" *ngIf="isMuvitSelected">
            <app-sis-select
              label="Destino"
              [options]="destinationOptions"
              [loading]="loadingCountries"
              [loadedKey]="countriesLoadedKey"
              loadedMessage="Catálogo de destinos cargado"
              [loadFailed]="countriesLoadFailed"
              (retryLoad)="retryLoadCountries()"
              [error]="fieldError('complementary', 'destination')"

              [helper]="loadingCountries ? 'Cargando destinos...' : ''"
              formControlName="destination">
            </app-sis-select>
          </div>

          <!-- Campo "Sede" oculto: se usa una sede por defecto seleccionada
               automáticamente (selectInitialCreationAddress). El control sigue en
               el formulario y conserva su valor. -->

          <div class="field">
            <app-sis-date-field label="Fecha de Inicio de Vigencia" [error]="fieldError('complementary', 'effectiveDate')" formControlName="effectiveDate"></app-sis-date-field>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- PEP retirado del paso del titular: ni asistencias ni seguros lo capturan.
       El grupo sigue en el formulario con sus valores por defecto y viaja en
       collected_data, igual que antes para asistencias. -->

  <div class="actions">
    <app-sis-button variant="secondary" (pressed)="cancel()">Cancelar</app-sis-button>
    <app-sis-button [disabled]="!isStepValid" (pressed)="goToNextStep($event)">Continuar</app-sis-button>
  </div>

</div>
